
const customerConsultant = [
  {
    path: '/customer-consultant',
    name: 'customer-consultant',
    component: () => import('@/views/wxapp/customer-consultant/'),
    redirect: 'customer-consultant/invite',
    meta: {
      title: '家装顾问'
    },
    children: [
      {
        path: 'invite',
        name: 'rad-invite',
        component: () => import('@/views/wxapp/customer-consultant/rad1/invite'),
        meta: {
          title: '创建初步需求评估邀请'
        }
      }
    ]
  }
]
export default customerConsultant
